export enum SchoolGroupsListColumns {
  NAME = 'Name',
  DESCRIPTION = 'Description',
  ACTIVE = 'Deactivated On',
  ACTIONS = 'Actions',
}
